// PublicEventTrigger.ts
// Mirrors ConneXt v2 PublicEventTrigger: event-based trigger with RepeatAfter + RepeatableOnConversation.
import { BaseTrigger } from "./BaseTrigger";
export class PublicEventTrigger extends BaseTrigger {
    constructor() {
        super(...arguments);
        this.targetElement = null;
        this.eventHandler = null;
    }
    get selector() {
        return this.when.Selector || "";
    }
    get eventName() {
        return this.when.EventName || "";
    }
    init() {
        if (!this.eventName)
            return;
        this.targetElement = this.selector
            ? document.querySelector(this.selector) || document
            : document;
        this.eventHandler = (e) => this.handlerAction(e);
        this.targetElement.addEventListener(this.eventName, this.eventHandler);
    }
    handlerAction(e) {
        e.stopPropagation();
        if (this.canTrigger()) {
            this.startTimer(() => {
                this.markTriggered();
                this.actionInstance.execute();
            });
        }
    }
    unRegister() {
        super.unRegister();
        if (this.targetElement && this.eventHandler) {
            this.targetElement.removeEventListener(this.eventName, this.eventHandler);
        }
    }
}
